export default "__VITE_ASSET__y1lzpjha__"